const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "PulseFeed" */ './views/HomeView.vue'),
    meta: { i18n: 'pulse-pov', pageNameEn: 'Home' },
  },
];

export default routes;
